import { Observable, of } from 'rxjs';
import {
  GenericDataResponse,
  HemsFeaturesPresentSincePayload,
  HemsFeaturesPresentSinceResponse,
} from '../analytics/analytics.model';
import { RemoteServiceApiModel } from './remote-service.api-model';
import { MockedDeviceAvailableHemsProperties } from './remote-service.mocks';
import { mockEndpointDelay } from '../demo-constants';
import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  DiagnosisExplanation,
  DiagnosisExplanationParams,
  DiagnosisWhitelistResponse,
} from './remote-service.model';

@Injectable({ providedIn: 'root' })
export class RemoteServiceMockApi implements RemoteServiceApiModel {
  getDeviceAvailableHemsProperties(
    body: HemsFeaturesPresentSincePayload
  ): Observable<GenericDataResponse<HemsFeaturesPresentSinceResponse>> {
    return of(new MockedDeviceAvailableHemsProperties().mock(body)).pipe(delay(mockEndpointDelay));
  }

  getDiagnosisWhitelist(_boilerId: string): Observable<DiagnosisWhitelistResponse> {
    return of({ data: { diagnoses: [] } });
  }

  getDiagnosisExplanation(_params: DiagnosisExplanationParams): Observable<DiagnosisExplanation> {
    return of(null);
  }
}
